import UpdateItemRelocate from "../../../../components/@documents/item_relocates/UpdateItemRelocate";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function ItemRelocateUpdatePage() {

    return (
        <UpdateItemRelocate 
            routeType={routeTypes.admin}
        />
    )
}